<template>
    <div class="width100" id="info_fotos">
        <div class="clear"></div>

        <div class="shadow width100 marginbottom15">
            <div class="padding20 lineheight22">
                <div v-if="imgs.length > 0" class="width100">
                    <div id="slider_epic">
                        <div>
                            <transition
                                name="fade"
                                mode="in-out"
                                appear
                                v-if="!showVideo"
                            >
                                <img
                                    v-if="shown"
                                    :alt="currentImageIndex"
                                    :src="activeImage()"
                                    style="width: 100%;"
                                    class="activeImage"
                                />
                            </transition>
                            <WistiaVideo
                                class="activeImage"
                                v-if="shown & showVideo"
                                :videoID="video"
                            />
                        </div>

                        <span
                            v-on:click="prevImageClick"
                            class="slider_arrow_left"
                        >
                            <span
                                ><font-awesome-icon size="3x" icon="angle-left"
                            /></span>
                        </span>

                        <span
                            v-on:click="nextImageClick"
                            class="slider_arrow_right"
                        >
                            <span
                                ><font-awesome-icon size="3x" icon="angle-right"
                            /></span>
                        </span>
                        <div class="clear"></div>
                    </div>
                    <div class="height10 clear"></div>

                    <div class="cruisethumbnails floatleft width100">
                        <img
                            :src="videoThumbnail"
                            alt="Video"
                            @click="toggleVideo"
                        />
                        <img
                            v-for="(img, index) in imgs"
                            :key="'CruiseThumbnail' + index"
                            :src="thumbOrUrl(img)"
                            v-on:click="setActiveImage(index)"
                            v-on:error="setImageMissing(index)"
                            :class="cssIsActive(index)"
                            class="thumbimg floatleft marginright5"
                            :data-index="index"
                            :id="'thumb' + index"
                            :alt="index"
                            style="cursor: pointer;"
                            height="50"
                        />
                    </div>
                    <div class="clear height10"></div>
                </div>

                <div class="clear floatleft"></div>
            </div>
        </div>
        <div class="clear height10"></div>
    </div>
</template>

<script>
import WistiaVideo from './WistiaVideo'
export default {
    name: 'CruiseImages',
    components: {
        WistiaVideo,
    },

    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            currentImageIndex: 0,
            shown: true,
            showVideo: false,
            thumbWidth: 105,
            animateDuration: 500,
            slideShowWaitTime: 5000,
            timer: null,
        }
    },
    props: {
        imgs: Array,
        video: String,
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth
            this.window.height = window.innerHeight
        },
        thumbOrUrl: function(image) {
            if (image && image.hashurl && image.extension) {
                return (
                    image.hashurl.replace('.' + image.extension, '') +
                    '_thumb' +
                    '.' +
                    image.extension
                )
            } else if (image && image.url) {
                return image.url
            }
            return ''
        },
        hashOrUrl: function(image) {
            if (image && image.hashurl) {
                return image.hashurl
            } else {
                return image.url
            }
        },
        setActiveImage: function(index) {
            this.showVideo = false
            this.currentImageIndex = parseInt(index)
            this.scrollToActiveThumbIndex()
        },
        setImageMissing: function(index) {
            // remove missing image from imgs array
            let missingImage = this.imgs[index]
            this.imgs.splice(index, 1)
            this.$store.dispatch(
                'saveLog',
                'Missing image removed from list, index: ' +
                    index +
                    ' details: ' +
                    JSON.stringify(missingImage)
            )
        },
        cssIsActive: function(index) {
            let isSelected =
                parseInt(index) === parseInt(this.currentImageIndex)
            return { active: isSelected, inactive: !isSelected }
        },
        nextImageClick: function() {
            this.showVideo = false
            this.nextImage()
        },
        nextImage: function() {
            this.showVideo = false
            this.currentImageIndex += 1
            if (this.currentImageIndex > this.imgCount) {
                this.currentImageIndex = 0
            }
            this.scrollToActiveThumbIndex()
        },
        prevImageClick: function() {
            this.showVideo = false
            this.prevImage()
        },
        prevImage: function() {
            this.showVideo = false
            this.currentImageIndex -= 1

            if (this.currentImageIndex < 0) {
                this.currentImageIndex = this.imgCount
            }
            this.scrollToActiveThumbIndex()
        },
        scrollToActiveThumbIndex: function() {
            let thumbWidth = this.thumbWidth
            let animateDuration = this.animateDuration
            this.$nextTick(function() {
                $('.cruisethumbnails')
                    .stop()
                    .animate(
                        {
                            scrollLeft: this.currentImageIndex * thumbWidth,
                        },
                        animateDuration
                    )
                this.shown = true
            })
        },
        activeImage: function() {
            return this.hashOrUrl(this.imgs[parseInt(this.currentImageIndex)])
        },
        startSlideShow: function() {
            if (this.window.width > 1000 && !this.showVideo) {
                let self = this
                let slideShowWaitTime = this.slideShowWaitTime
                this.timer = setTimeout(function() {
                    self.nextImage()
                    self.startSlideShow()
                }, slideShowWaitTime)
            }
        },

        toggleVideo: function() {
            this.showVideo = !this.showVideo
            clearTimeout(this.timer)
        },
    },
    computed: {
        imgCount: function() {
            return Object.keys(this.imgs).length - 1
        },
        videoThumbnail: function() {
            return this.$store.state.cruise.rederij_thumbnail_url
        },
    },
    mounted: function() {
        this.startSlideShow()
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
}
</script>

<style scoped>
.img-wrapper {
    overflow: hidden;
    height: 450px;
}

.activeImage {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
}

.cruisethumbnails {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
}

.cruisethumbnails img {
    display: inline;
    float: none !important;
    width: 100px;
    height: 60px;
    margin-bottom: 5px;
}
</style>
